import { axios } from './axios';

export const getSageSync = () => axios.get(`/v1/sync/sage`);
